import axios from 'axios';

export default {
    methods: {
        async permissionsIndex(ok, err) {
            try {
                let r = await axios.get('permissions');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async permissionsStore(params, ok, err) {
            try {
                let r = await axios.post('permissions', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async permissionsShow(id, ok, err) {
            try {
                let r = await axios.get('permissions/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async permissionsUpdate(params, ok, err) {
            try {
                let r = await axios.put('permissions/' + params.id, params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async permissionsDestroy(id, ok, err) {
            try {
                let r = await axios.get('permissions/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async permissionsList(ok, err) {
            try {
                let r = await axios.post('permissions/list');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth/permissions.js